import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, AfterUseQuestionnaire } from "../store_types"
import { callAfterUseQuestionnairesAPI, callDownloadAfterUseQuestionnairesAPI, callAfterUseQuestionnairesBulkUpdateAPI } from "../../api/after_use_questionnaires"
import { HTTP_STATUS_NO_CONTENT } from "../../api/index"
import { AxiosResponseHeaders } from "axios"
import { saveAs } from "file-saver"

const getDefaultState  = () => {
  return {
    afterUseQuestionnaires: [],
    afterUseQuestionnairesPublished: false
  }
}

const afterUseQuestionnaires = {
  state: () => getDefaultState(),

  getters: {
    afterUseQuestionnaires (state : State) {
      return state.afterUseQuestionnaires
    },
    afterUseQuestionnairesPublished (state : State) {
      return state.afterUseQuestionnairesPublished
    },
  },

  actions: {
    fetchAfterUseQuestionnaires({ dispatch, commit, getters }: { dispatch: (actionName: string, result: boolean) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders | Array<AfterUseQuestionnaire>) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callAfterUseQuestionnairesAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedQuestionnaireDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, afterUseQuestionnaires:  Array<AfterUseQuestionnaire>, afterUseQuestionnairesPublished: boolean) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_AFTER_USE_QUESTIONNAIRES, afterUseQuestionnaires)
            dispatch("fetchAfterUseQuestionnairesPublished", afterUseQuestionnairesPublished)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    downloadAfterUseQuestionnaires({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callDownloadAfterUseQuestionnairesAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedQuestionnaireDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, csvData: Blob) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            const targetMonth = getters.selectedQuestionnaireDate as Date
            saveAs(csvData, `利用後アンケートフリー回答一覧_${targetMonth.getFullYear()}年${targetMonth.getMonth() + 1}月.csv`)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    updateAfterUseQuestionnaires({ dispatch, commit, getters }: { dispatch: (actionName: string) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders) => void, getters: { [key: string]: AuthHeaders }}, params: Array<{id: number, requestOrOpinion: string}>){
      return new Promise<void>((resolve, reject) => {
        callAfterUseQuestionnairesBulkUpdateAPI(
          getters.authHeaders as AuthHeaders,
          params,
          // Success
          (headers: AxiosResponseHeaders, status: number) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            if(status == HTTP_STATUS_NO_CONTENT) {
              dispatch("fetchAfterUseQuestionnaires")
            }
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    fetchAfterUseQuestionnairesPublished({ commit }: { commit: (mutationType:string, published: boolean) => void}, published: boolean){
      return new Promise<void>((resolve) => {
        commit(MutationTypes.ASSIGN_AFTER_USE_QUESTIONNAIRES_PUBLISHED, published)
        resolve()
      })
    },

    resetAfterUseQuestionnairesState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_AFTER_USE_QUESTIONNAIRES_STATE)
    },
  },

  mutations: {
    [MutationTypes.ASSIGN_AFTER_USE_QUESTIONNAIRES](state: State, afterUseQuestionnaires: Array<AfterUseQuestionnaire>) {
      state.afterUseQuestionnaires = afterUseQuestionnaires
    },
    [MutationTypes.ASSIGN_AFTER_USE_QUESTIONNAIRES_PUBLISHED](state: State, afterUseQuestionnairesPublished: boolean) {
      state.afterUseQuestionnairesPublished = afterUseQuestionnairesPublished
    },
    [MutationTypes.RESET_AFTER_USE_QUESTIONNAIRES_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  }
}

export default afterUseQuestionnaires
